import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Amina Karisa",
    role: "Villa Owner, Shanzu Serena",
    avatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80",
    comment:
      "KeDe-Ceaning transformed our beach house after the monsoon season. Their window cleaning cleared away salt stains effortlessly, and the garden team is top tier!",
  },
  {
    name: "David Mwangi",
    role: "Boutique Hotel Director, Bamburi",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=300&q=80",
    comment:
      "We rely on KeDe-Ceaning for both weekly exterior lawn mowing and emergency repair jobs. Professional, punctual, and reliable every single time.",
  },
  {
    name: "Sarah Hassan",
    role: "Apartment Complex Manager, Nyali",
    avatar: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=300&q=80",
    comment:
      "They handled full interior and exterior repainting for our 12 units. Impeccable finish and great attention to detail. Highly recommend in Mombasa!",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-14 max-w-2xl"
      >
        <p className="font-jbm text-xs font-semibold uppercase tracking-[0.3em] text-[#C85A32]">Word on the coast</p>
        <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-[#1C3B2B] sm:text-4xl lg:text-5xl">
          Neighbours who trust KeDe-Ceaning
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 md:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            data-testid={`testimonial-card-${i + 1}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="relative rounded-3xl border border-[#E4DDD3] bg-white p-8 shadow-[0_25px_50px_-30px_rgba(28,59,43,0.3)] transition-transform duration-500 hover:-translate-y-2"
          >
            <Quote size={36} className="absolute right-7 top-7 text-[#F3EDE2]" />
            <div className="flex gap-1 text-[#D4A359]">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} size={15} fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <blockquote className="mt-5 text-sm leading-relaxed text-[#525B53] sm:text-base">"{t.comment}"</blockquote>
            <figcaption className="mt-7 flex items-center gap-4">
              <img src={t.avatar} alt={t.name} loading="lazy" className="h-12 w-12 rounded-full border-2 border-[#F3EDE2] object-cover" />
              <div>
                <p className="font-display text-sm font-bold text-[#1A1C18]">{t.name}</p>
                <p className="text-xs text-[#7B867C]">{t.role}</p>
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
